<template>
  <div>
    <div v-if="!isSuccess" class="admin-invite-modal">
      <modal redesign @close="close">
        <div slot="header">{{ headerTitle }}</div>
        <div slot="body" class="basic-form">
          <div class="row-block">
            <div class="input-wrapper">
              <input
                v-model="email"
                :placeholder="$tr('admin.companies.inviteModal.emailLabel')"
                type="email"
                name="email"
              />
            </div>
          </div>
          <div class="row-block">
            <div class="input-wrapper">
              <languages-select v-model="lang" :has-label="false" />
            </div>
          </div>
        </div>
        <div slot="footer">
          <vbutton
            :text="buttonText"
            :disabled="!email || loading"
            :loading="loading"
            @click="submit"
          />
        </div>
      </modal>
    </div>
    <div v-else class="admin-invite-model-success">
      <modal redesign @close="close">
        <div slot="header">
          <img class="header-image" src="/static/images/elements/modal-success.png" />
          <span>{{ successTitle }}</span>
        </div>
        <div slot="footer">
          <vbutton :text="$tr('common.ok')" @click="close" />
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  import Modal from '@/components/Modal.vue';
  import LanguagesSelect from '@/components/vacancy/preferences/SettingsLanguagesSelect';

  export default {
    name: 'InviteModal',

    components: {
      Modal,
      LanguagesSelect
    },

    props: {
      title: {
        type: String,
        default: ''
      },

      buttonLabel: {
        type: String,
        default: ''
      },

      successText: {
        type: String,
        default: ''
      },

      isSuccess: {
        type: Boolean,
        defaul: false
      },

      loading: {
        type: Boolean,
        defaul: false
      }
    },

    data() {
      return {
        email: '',
        lang: null
      };
    },

    computed: {
      headerTitle() {
        if (!this.title) {
          return this.$tr('admin.companies.inviteModal.title');
        }

        return this.title;
      },

      userLanguage() {
        return this.$store.getters['user/current']
          ? this.$store.getters['user/current'].language
          : null;
      },

      buttonText() {
        if (!this.buttonLabel) {
          return this.$tr('admin.companies.inviteModal.buttonLabel');
        }

        return this.buttonLabel;
      },

      successTitle() {
        if (!this.successText) {
          return this.$tr('admin.companies.inviteModal.successTitle');
        }
        return this.successText;
      }
    },

    mounted() {
      if (this.userLanguage) {
        this.lang = this.userLanguage;
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      submit() {
        this.$emit('submit', { email: this.email, language: this.lang });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .admin-invite-model-success,
  .admin-invite-modal {
    ::v-deep {
      .basic-form {
        .row-block {
          margin-bottom: 1rem !important;

          &:last-child {
            margin-bottom: 0 !important;
          }
        }
      }
      .modal-mask.redesign {
        .modal-wrapper {
          display: flex;
          justify-content: center;

          .close-icon {
            top: 15px;
            right: 15px;
            color: #7f8b99;
          }
        }
        .modal-container {
          display: inline-flex;
          flex-direction: column;
          margin: 0 auto;
          padding: 44px 0;
          max-width: 520px;
          min-width: 520px;
          box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
          border-radius: 2px;

          .modal-body {
            margin: 20px auto 30px;
          }

          .basic-form {
            .row-block {
              justify-content: center;
              margin-bottom: 0;
            }
            .input-wrapper {
              width: 300px;

              input {
                height: 40px;
              }
            }
          }
        }

        .modal-header {
          font-style: normal;
          font-weight: 500;
          font-size: 28px;
          line-height: 41px;
          color: #233346;
          text-align: center;
        }
      }
    }
  }

  .admin-invite-model-success {
    ::v-deep {
      .modal-mask.redesign {
        .modal-container {
          padding: 31px 0;
          .modal-body {
            display: none;
          }
        }
      }
      .header-image {
        width: 60px;
        height: 60px;
        margin-bottom: 15px;
      }

      .modal-header {
        margin-bottom: 20px;

        & > div {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }
</style>
